import { useMemo } from 'react';
import { PerformanceResultType } from '@/gql/enums';
import type { PerformanceResultUserFragment } from '@/gql/graphql';
import CreatePerformanceBmpModal from '../Bmp/Create/CreatePerformanceBmpModal';
import CreatePerformanceFinSwimModal from '../FinSwim/Create/CreatePerformanceFinSwimModal';
import CreatePerformanceIpptModal from '../Ippt/Create/CreatePerformanceIpptModal';
import CreatePerformanceMarch20KmModal from '../March20km/Create/CreatePerformanceMarch20KmModal';
import CreatePerformanceSocModal from '../Soc/Create/CreatePerformanceSocModal';
import CreatePerformanceWeightModal from '../Weight/Create/CreatePerformanceWeightModal';
import type { AssessmentRunOption } from './utils';

export interface CreatePerformanceResultModalProps {
    open: boolean;
    onClose: (refresh?: boolean) => void;
    groupUsers: PerformanceResultUserFragment[];
    resultType: PerformanceResultType;
    assessmentRunOptions: AssessmentRunOption[];
}

const CreatePerformanceResultModal = ({
    open,
    onClose,
    groupUsers,
    resultType,
    assessmentRunOptions,
}: CreatePerformanceResultModalProps) => {
    const ModalComponent = useMemo(() => {
        const mapping = {
            [PerformanceResultType.Soc]: CreatePerformanceSocModal,
            [PerformanceResultType.Ippt]: CreatePerformanceIpptModal,
            [PerformanceResultType.Weight]: CreatePerformanceWeightModal,
            [PerformanceResultType.Bmp]: CreatePerformanceBmpModal,
            [PerformanceResultType.FinSwim]: CreatePerformanceFinSwimModal,
            [PerformanceResultType.March20km]: CreatePerformanceMarch20KmModal,
        };

        return mapping[resultType as keyof typeof mapping] ?? null;
    }, [resultType]);

    if (!ModalComponent) {
        return null;
    }

    return (
        <ModalComponent
            key={`${resultType}-${open ? 'open' : 'closed'}`}
            open={open}
            onClose={onClose}
            groupUsers={groupUsers}
            assessmentRunOptions={assessmentRunOptions}
        />
    );
};

export default CreatePerformanceResultModal;
